import { IconButton } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { SharedUserRow } from "./SharedUserRow";
import { NameBlock } from "./NameBlock";
import { UserThatShareCampaign } from "../../../../types/apiTypes";
import { PermissionRoles } from "../../../../types/enums";
import { ReuseTooltip } from "../../ReuseTooltip";
import { SharedUserMenu } from "./SharedUserMenu";
import { ManagePermissionsModal } from "../ManagePermissionsModal";
import { PermissionRoleMapper } from "../../../company";
import { PersonWithPenIcon } from "../../../images";

type Props = {
  user: UserThatShareCampaign;
  isOwner: boolean;
  setHideModal: (isHide: boolean) => void;
  changeUserPermissionsHandler: (updatedUser: UserThatShareCampaign) => void;
  removeUserHandler: (id: string) => void;
};

export const SharedUser = memo(
  ({
    user,
    isOwner,
    setHideModal,
    changeUserPermissionsHandler,
    removeUserHandler,
  }: Props) => {
    const { first_name, last_name, avatar_url, email, role } = user;
    const [isPermissionModal, setIsPermissionModal] = useState<boolean>(false);

    useEffect(() => {
      setHideModal(isPermissionModal);
    }, [isPermissionModal]);

    const changePermissionHandler = (updatedUser: UserThatShareCampaign) => {
      changeUserPermissionsHandler(updatedUser);
      setIsPermissionModal(false);
    };

    return (
      <>
        <SharedUserRow
          nameBlock={
            <NameBlock
              fullname={`${first_name} ${last_name}`}
              avatar_url={avatar_url}
              email={email}
              isCurrentUser={isOwner}
            />
          }
          roleBlock={
            <PermissionRoleMapper role={role || PermissionRoles.agency_team} />
          }
          permissionBlock={
            <ReuseTooltip
              text={
                isOwner
                  ? ""
                  : "Configure which features are visible and editable for this user."
              }
              maxWidth="200px"
              hideChildren={false}
            >
              <IconButton
                aria-label="more"
                id="long-button"
                aria-haspopup="true"
                onClick={() => setIsPermissionModal(true)}
                style={{
                  padding: 0,
                  borderRadius: "8px",
                  width: "40px",
                  height: "40px",
                }}
                disabled={isOwner}
              >
                <PersonWithPenIcon />
              </IconButton>
            </ReuseTooltip>
          }
          menuBlock={
            <SharedUserMenu
              isDisabled={isOwner}
              removeUserHandler={() => removeUserHandler(user.user_id)}
            />
          }
          withBg={false}
        />

        {isPermissionModal && (
          <ManagePermissionsModal
            user={user}
            isOpen={isPermissionModal}
            onClose={() => setIsPermissionModal(false)}
            onSuccess={changePermissionHandler}
            isLoading={false}
            isShare={true}
            role={user.role}
          />
        )}
      </>
    );
  },
);
